(function () {
    "use strict";

    let featureCards = [];
	let swipers = [];
	let isAuthor = false;


    function initFeatureCards() {
        featureCards = document.querySelectorAll(".cmp-flindersonline-feature-card");
		
        setCardHeights();
        setupCardOverlay();
        setupCarousel();
        setupVideoPlayer();
        setupPopupModal();
        setupPillAnimation();
    }

	function setCardHeights() {
		featureCards.forEach(card => {
			// Try different ways to access the height attributes
			const desktopHeight = card.dataset.minHeightDesktop || 
								  card.getAttribute('data-min-height-desktop');
			
			const mobileHeight = card.dataset.minHeightMobile || 
								 card.getAttribute('data-min-height-mobile');
			
			if (desktopHeight || mobileHeight) {
				// Find all .card elements within this feature card
				const cardElements = card.querySelectorAll('.card');
				
				cardElements.forEach(cardElement => {
					// Apply desktop height by default
					if (desktopHeight) {
						cardElement.style.minHeight = desktopHeight + 'px';
					}
					
					// Apply mobile height for smaller screens using CSS media query
					if (mobileHeight) {
						// Create a style element for media query if it doesn't exist
						let styleId = 'feature-card-mobile-heights';
						let styleElement = document.getElementById(styleId);
						
						if (!styleElement) {
							styleElement = document.createElement('style');
							styleElement.id = styleId;
							document.head.appendChild(styleElement);
						}
						
						// Generate a unique class for this card element
						const uniqueClass = `feature-card-${Math.random().toString(36).substr(2, 9)}`;
						cardElement.classList.add(uniqueClass);
						
						// Add mobile media query rule
						const existingRules = styleElement.textContent || '';
						const newRule = `@media (max-width: 768px) { .${uniqueClass} { min-height: ${mobileHeight}px !important; } }`;
						
						if (!existingRules.includes(uniqueClass)) {
							styleElement.textContent = existingRules + newRule;
						}
					}
				});
			}
		});
	}

	function setupCardOverlay() {
		featureCards.forEach(card => {
			// Check if this is an author environment
			isAuthor = card.dataset.author === 'true';
			
			// Skip setup in author mode to prevent interference with editing
			if (isAuthor) {
				return;
			}

			// Find content overlay cards (similar to text overlay in contentcard-carousel)
			const contentOverlayCards = card.querySelectorAll('.card__content-overlay');
			
			contentOverlayCards.forEach((overlayCard) => {
				const toggleBtn = overlayCard.querySelector('.card-toggle');
				const mainCard = overlayCard.querySelector('.main-card');
				const overlayContent = overlayCard.querySelector('.overlay-card');
				
				if (!toggleBtn || !mainCard || !overlayContent) return;
				
				// Set initial state
				let isOverlayVisible = false;
				
				// Ensure initial state - overlay is hidden
				overlayContent.style.display = 'none';
				overlayContent.style.opacity = '0';
				mainCard.style.display = 'block';
				mainCard.style.opacity = '1';
				
				// Get the toggle icon for rotation
				const toggleIcon = toggleBtn.querySelector('.plus-sign i');
				
				toggleBtn.addEventListener('click', function(e) {
					e.preventDefault();
					e.stopPropagation();
					
					if (!isOverlayVisible) {
						// Show overlay content
						overlayCard.classList.add('overlay-active');
						
						// Animate main card out
						mainCard.style.transition = 'opacity 0.3s ease';
						mainCard.style.opacity = '0';
						
						// Wait for main card to fade out, then show overlay
						setTimeout(() => {
							mainCard.style.display = 'none';
							overlayContent.style.display = 'block';
							
							// Force reflow
							void overlayContent.offsetWidth;
							
							// Animate overlay in
							overlayContent.style.transition = 'opacity 0.3s ease';
							overlayContent.style.opacity = '1';
							
							// Reinitialize text highlight animations for overlay content
							if (typeof window.reinitializeTextHighlightAnimation === 'function') {
								window.reinitializeTextHighlightAnimation(overlayContent);
							}
						}, 300);
						
						// Rotate button to X (45 degrees)
						if (toggleIcon) {
							toggleIcon.style.transform = 'rotate(45deg)';
							toggleIcon.style.transition = 'transform 0.3s ease';
						}
						
						isOverlayVisible = true;
					} else {
						// Hide overlay content
						overlayCard.classList.remove('overlay-active');
						
						// Animate overlay out
						overlayContent.style.transition = 'opacity 0.3s ease';
						overlayContent.style.opacity = '0';
						
						// Wait for overlay to fade out, then show main card
						setTimeout(() => {
							overlayContent.style.display = 'none';
							mainCard.style.display = 'block';
							
							// Force reflow
							void mainCard.offsetWidth;
							
							// Animate main card in
							mainCard.style.transition = 'opacity 0.3s ease';
							mainCard.style.opacity = '1';
						}, 300);
						
						// Reset button rotation
						if (toggleIcon) {
							toggleIcon.style.transform = 'rotate(0deg)';
							toggleIcon.style.transition = 'transform 0.3s ease';
						}
						
						isOverlayVisible = false;
					}
				});
				
				// Also handle the toggle button in the overlay card (if it exists)
				const overlayToggleBtn = overlayContent.querySelector('.card-toggle');
				if (overlayToggleBtn && overlayToggleBtn !== toggleBtn) {
					const overlayToggleIcon = overlayToggleBtn.querySelector('.plus-sign i');
					
					overlayToggleBtn.addEventListener('click', function(e) {
						e.preventDefault();
						e.stopPropagation();
						
						// Hide overlay content (same logic as above)
						overlayCard.classList.remove('overlay-active');
						
						// Animate overlay out
						overlayContent.style.transition = 'opacity 0.3s ease';
						overlayContent.style.opacity = '0';
						
						// Wait for overlay to fade out, then show main card
						setTimeout(() => {
							overlayContent.style.display = 'none';
							mainCard.style.display = 'block';
							
							// Force reflow
							void mainCard.offsetWidth;
							
							// Animate main card in
							mainCard.style.transition = 'opacity 0.3s ease';
							mainCard.style.opacity = '1';
						}, 300);
						
						// Reset both button rotations
						if (toggleIcon) {
							toggleIcon.style.transform = 'rotate(0deg)';
							toggleIcon.style.transition = 'transform 0.3s ease';
						}
						if (overlayToggleIcon) {
							overlayToggleIcon.style.transform = 'rotate(0deg)';
							overlayToggleIcon.style.transition = 'transform 0.3s ease';
						}
						
						isOverlayVisible = false;
					});
				}
			});
		});
	}

	function setupCarousel() {
		featureCards.forEach(card => {
			// Check if this is an author environment
			isAuthor = card.dataset.author === 'true';
			
			// Skip setup in author mode to prevent interference with editing
			if (isAuthor) {
				return;
			}

			// Find carousel text cards
			const carouselCards = card.querySelectorAll('.card__carousel-text');
			
			carouselCards.forEach((carouselCard) => {
				const textContent = carouselCard.querySelector('.carousel-text-content');
				const slides = carouselCard.querySelectorAll('.carousel-description');
				const prevBtn = carouselCard.querySelector('.carousel-nav-button:first-child');
				const nextBtn = carouselCard.querySelector('.carousel-nav-button:last-child');
				const pagination = carouselCard.querySelector('.pagination-item-number');
				
				if (!textContent || slides.length === 0 || !prevBtn || !nextBtn || !pagination) return;
				
				let currentSlide = 0;
				const totalSlides = slides.length;
				const additionalSpace = 40;
				
				// Initialize slides - hide all except first
				slides.forEach((slide, index) => {
					if (index === 0) {
						gsap.set(slide, { 
							opacity: 1, 
							y: 0, 
							display: 'block',
							visibility: 'visible',
							position: 'relative' // First slide is relative for natural height
						});
					} else {
						gsap.set(slide, { 
							opacity: 0, 
							y: 30, 
							display: 'none',
							visibility: 'hidden',
							position: 'absolute' // Other slides are absolute
						});
					}
				});
				
				// Set initial container height based on first slide
				const setInitialHeight = () => {
					const firstSlideHeight = slides[0].offsetHeight;
					if (firstSlideHeight > 0) {
						textContent.style.minHeight = (firstSlideHeight + additionalSpace) + 'px';
					} else {
						// If height is 0, try again after a short delay
						setTimeout(setInitialHeight, 100);
					}
				};
				
				// Use setTimeout to ensure proper height calculation after DOM is ready
				setTimeout(setInitialHeight, 50);
				
				// Update pagination
				function updatePagination() {
					pagination.textContent = `${currentSlide + 1}/${totalSlides}`;
				}
				
				// Track if animation is in progress to prevent rapid clicking
				let isAnimating = false;
				
				// Animate to next/prev slide
				function animateToSlide(direction) {
					if (isAnimating) return; // Prevent multiple animations
					
					const currentSlideElement = slides[currentSlide];
					
					// Determine next slide index
					let nextSlideIndex;
					if (direction === 'next') {
						nextSlideIndex = currentSlide === totalSlides - 1 ? 0 : currentSlide + 1;
					} else {
						nextSlideIndex = currentSlide === 0 ? totalSlides - 1 : currentSlide - 1;
					}
					
					const nextSlideElement = slides[nextSlideIndex];
					
					// Update pagination immediately
					currentSlide = nextSlideIndex;
					updatePagination();
					
					// Get heights for smooth container transition
					const currentHeight = currentSlideElement.offsetHeight;
					
					// Temporarily show next slide to get its height
					const nextSlideOriginalDisplay = nextSlideElement.style.display;
					const nextSlideOriginalVisibility = nextSlideElement.style.visibility;
					const nextSlideOriginalOpacity = nextSlideElement.style.opacity;
					
					gsap.set(nextSlideElement, {
						display: 'block',
						visibility: 'visible',
						opacity: 0,
						position: 'absolute'
					});
					
					const rawHeight = nextSlideElement.offsetHeight
					const nextHeight = rawHeight + additionalSpace;
					
					// Restore original state
					gsap.set(nextSlideElement, {
						display: nextSlideOriginalDisplay,
						visibility: nextSlideOriginalVisibility,
						opacity: nextSlideOriginalOpacity
					});
					
					// Disable buttons during animation
					isAnimating = true;
					prevBtn.disabled = true;
					nextBtn.disabled = true;
					
					// Create timeline for smooth animation
					const tl = gsap.timeline({
						onComplete: () => {
							isAnimating = false;
							prevBtn.disabled = false;
							nextBtn.disabled = false;
							
							// Reset container to use minHeight instead of fixed height
							textContent.style.height = 'auto';
							textContent.style.minHeight = nextHeight + 'px';
						}
					});
					
					// Set container height to current height to prevent jumping during animation
					textContent.style.height = Math.max(currentHeight, nextHeight) + 'px';
					textContent.style.minHeight = '0px';
					
					// Animate current slide out (fade out and slide DOWN)
					tl.to(currentSlideElement, {
						opacity: 0,
						y: 30, // Slide DOWN (positive value)
						duration: 0.4,
						ease: "power2.inOut"
					})
					// Hide current slide and prepare next slide
					.set(currentSlideElement, {
						display: 'none',
						visibility: 'hidden'
					})
					.set(nextSlideElement, {
						display: 'block',
						visibility: 'visible',
						opacity: 0,
						y: 30 // Start from below (positive value)
					})
					// Animate container height change (only if next content is smaller)
					.to(textContent, {
						height: nextHeight + 'px',
						duration: 0.4,
						ease: "power2.inOut"
					}, "-=0.1")
					// Animate next slide in (fade in and slide UP)
					.to(nextSlideElement, {
						opacity: 1,
						y: 0, // Slide UP to 0
						duration: 0.4,
						ease: "power2.inOut"
					}, "-=0.4"); // Start at the same time as height animation
				}
				
				// Event listeners for navigation buttons
				nextBtn.addEventListener('click', function(e) {
					e.preventDefault();
					e.stopPropagation();
					animateToSlide('next');
				});
				
				prevBtn.addEventListener('click', function(e) {
					e.preventDefault();
					e.stopPropagation();
					animateToSlide('prev');
				});
				
				// Initialize pagination
				updatePagination();
				
				// Add keyboard navigation support
				carouselCard.setAttribute('tabindex', '0');
				carouselCard.addEventListener('keydown', function(e) {
					if (e.key === 'ArrowLeft') {
						e.preventDefault();
						animateToSlide('prev');
					} else if (e.key === 'ArrowRight') {
						e.preventDefault();
						animateToSlide('next');
					}
				});
				
				// Handle window resize to update container height
				let resizeTimeout;
				const handleResize = () => {
					// Debounce resize events to avoid excessive calculations
					clearTimeout(resizeTimeout);
					resizeTimeout = setTimeout(() => {
						if (!isAnimating) { // Only update if not currently animating
							const currentSlideElement = slides[currentSlide];
							const newHeight = currentSlideElement.offsetHeight;
							
							// Update container minHeight to match current content
							textContent.style.minHeight = newHeight + 'px';
							
							// If container has fixed height, update it too
							if (textContent.style.height && textContent.style.height !== 'auto') {
								textContent.style.height = newHeight + 'px';
							}
						}
					}, 150); // 150ms debounce delay
				};
				
				// Add resize listener
				window.addEventListener('resize', handleResize);
				
				// Store cleanup function for potential future use
				carouselCard._cleanupResize = () => {
					window.removeEventListener('resize', handleResize);
					clearTimeout(resizeTimeout);
				};
			});
		});
	}

	function setupVideoPlayer() {
		featureCards.forEach(card => {
			// Check if this is an author environment
			isAuthor = card.dataset.author === 'true';
			
			// Skip setup in author mode to prevent interference with editing
			if (isAuthor) {
				return;
			}

			// Find video cards
			const videoCards = card.querySelectorAll('.card__video');
			
			videoCards.forEach((videoCard) => {
				const video = videoCard.querySelector('.feature-video');
				const playPauseBtn = videoCard.querySelector('.play-pause-btn');
				const muteUnmuteBtn = videoCard.querySelector('.mute-unmute-btn');
				const playIcon = playPauseBtn.querySelector('.play-icon');
				const pauseIcon = playPauseBtn.querySelector('.pause-icon');
				const soundOnIcon = muteUnmuteBtn.querySelector('.sound-on-icon');
				const soundOffIcon = muteUnmuteBtn.querySelector('.sound-off-icon');
				
				if (!video || !playPauseBtn || !muteUnmuteBtn) return;
				
				let isPlaying = false;
				let isMuted = true; // Start muted by default
				
				// Initialize video state
				video.muted = isMuted;
				video.currentTime = 0;
				
				// Set up autoplay
				video.autoplay = true;
				video.loop = true;
				
				// Update control icons based on state
				function updatePlayPauseIcon() {
					if (isPlaying) {
						playIcon.style.display = 'none';
						pauseIcon.style.display = 'block';
					} else {
						playIcon.style.display = 'block';
						pauseIcon.style.display = 'none';
					}
				}
				
				function updateMuteIcon() {
					if (isMuted) {
						soundOnIcon.style.display = 'none';
						soundOffIcon.style.display = 'block';
					} else {
						soundOnIcon.style.display = 'block';
						soundOffIcon.style.display = 'none';
					}
				}
				
				// Show controls (always visible now)
				function showControls() {
					videoCard.classList.add('controls-visible');
					videoCard.classList.remove('controls-hidden');
				}
				
				// Play/Pause functionality
				function togglePlayPause() {
					if (isPlaying) {
						video.pause();
						isPlaying = false;
						videoCard.classList.remove('playing');
					} else {
						video.play().then(() => {
							isPlaying = true;
							videoCard.classList.add('playing');
						}).catch(error => {
							console.error('Error playing video:', error);
						});
					}
					updatePlayPauseIcon();
				}
				
				// Mute/Unmute functionality
				function toggleMute() {
					isMuted = !isMuted;
					video.muted = isMuted;
					updateMuteIcon();
				}
				
				// Event listeners
				playPauseBtn.addEventListener('click', function(e) {
					e.preventDefault();
					e.stopPropagation();
					togglePlayPause();
				});
				
				muteUnmuteBtn.addEventListener('click', function(e) {
					e.preventDefault();
					e.stopPropagation();
					toggleMute();
				});
				
				// Handle video play event (for autoplay)
				video.addEventListener('play', function() {
					isPlaying = true;
					videoCard.classList.add('playing');
					updatePlayPauseIcon();
				});
				
				// Handle video pause event
				video.addEventListener('pause', function() {
					isPlaying = false;
					videoCard.classList.remove('playing');
					updatePlayPauseIcon();
				});
				
				// Video click to toggle play/pause
				video.addEventListener('click', function(e) {
					e.preventDefault();
					e.stopPropagation();
					togglePlayPause();
				});
				
				// Auto-start video when loaded (since we have autoplay)
				video.addEventListener('loadeddata', function() {
					// Try to play the video (autoplay might be blocked)
					const playPromise = video.play();
					if (playPromise !== undefined) {
						playPromise.then(() => {
							// Video started playing
							isPlaying = true;
							videoCard.classList.add('playing');
							updatePlayPauseIcon();
						}).catch(error => {
							// Autoplay was blocked, show play button
							console.error('Autoplay blocked:', error);
							isPlaying = false;
							updatePlayPauseIcon();
						});
					}
				});
				
				// Keyboard support
				videoCard.setAttribute('tabindex', '0');
				videoCard.addEventListener('keydown', function(e) {
					switch(e.key) {
						case ' ':
						case 'Enter':
							e.preventDefault();
							togglePlayPause();
							break;
						case 'm':
						case 'M':
							e.preventDefault();
							toggleMute();
							break;
					}
				});
				
				// Initialize UI state
				updatePlayPauseIcon();
				updateMuteIcon();
				
				// Initially show controls
				videoCard.classList.add('controls-visible');
			});
		});
	}

	function setupPopupModal() {
		featureCards.forEach(card => {
			// Check if this is an author environment
			isAuthor = card.dataset.author === 'true';
			
			// Skip setup in author mode to prevent interference with editing
			if (isAuthor) {
				return;
			}

			// Find popup modal cards
			const popupCards = card.querySelectorAll('.card__popupmodal');
			
			// Find all modals associated with this feature card
			const allModals = card.querySelectorAll('.feature-card-modal:not(.feature-card-modal-author-mode)');
			
			// Reset all modals to ensure they're hidden
			allModals.forEach(modal => {
				modal.style.display = 'none';
			});
			
			// Setup each popup card - in feature card, there should typically be only one
			popupCards.forEach((popupCard, index) => {
				
				const popupBtn = popupCard.querySelector('.cardtile-btn');
				if (!popupBtn) {
					console.error(`No popup button found for feature card ${index}`);
					return;
				}
				
				// For feature cards, we expect one modal per card
				const modal = allModals[index];
				
				if (!modal) {
					console.error(`No modal found for feature card popup ${index}`);
					return;
				}
				
				
				// Store a reference to the modal and its original parent/nextSibling for restoration
				popupCard.modalReference = modal;
				popupCard.modalOriginalParent = modal.parentNode;
				popupCard.modalOriginalNextSibling = modal.nextSibling;
				
				// Create a new clean button to avoid any existing event handlers
				const newBtn = popupBtn.cloneNode(true);
				popupBtn.parentNode.replaceChild(newBtn, popupBtn);
				
				// Setup click handler
				newBtn.addEventListener('click', function(e) {
					e.preventDefault();
					e.stopPropagation();
					
					// Get the modal from the card reference
					const targetModal = popupCard.modalReference;
					
					// Debugging: check if the modal exists before trying to open it
					if (!targetModal) {
						console.error('No modal associated with this feature card button');
						return false;
					}
					
					// Move the modal to body for better positioning if not already there
					if (targetModal.parentNode !== document.body) {
						document.body.appendChild(targetModal);
					}
					
					// Set inline styles directly
					targetModal.style.cssText = 'display: flex !important; position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 9999;';
					console.log('Feature card modal display style after setting:', targetModal.style.display);
					
					// Force reflow
					void targetModal.offsetWidth;
					
					// Reinitialize text highlight animations for modal content
					if (typeof window.reinitializeTextHighlightAnimation === 'function') {
						window.reinitializeTextHighlightAnimation(targetModal);
					}
					
					// Setup close button
					const closeBtn = targetModal.querySelector('.feature-card-modal-close');
					if (closeBtn) {
						// Remove existing handlers by cloning
						const newCloseBtn = closeBtn.cloneNode(true);
						closeBtn.parentNode.replaceChild(newCloseBtn, closeBtn);
						
						newCloseBtn.addEventListener('click', function(evt) {
							evt.preventDefault();
							evt.stopPropagation();
							targetModal.style.display = 'none';
							
							// Move modal back to its original position
							if (popupCard.modalOriginalParent && popupCard.modalOriginalNextSibling) {
								popupCard.modalOriginalParent.insertBefore(targetModal, popupCard.modalOriginalNextSibling);
							} else if (popupCard.modalOriginalParent) {
								popupCard.modalOriginalParent.appendChild(targetModal);
							}
						});
					} else {
						console.error('No close button found in feature card modal');
					}
					
					// Handle background click
					targetModal.addEventListener('click', function(evt) {
						if (evt.target === targetModal) {
							targetModal.style.display = 'none';
							
							// Move modal back to its original position
							if (popupCard.modalOriginalParent && popupCard.modalOriginalNextSibling) {
								popupCard.modalOriginalParent.insertBefore(targetModal, popupCard.modalOriginalNextSibling);
							} else if (popupCard.modalOriginalParent) {
								popupCard.modalOriginalParent.appendChild(targetModal);
							}
						}
					});
					
					// Prevent default again for good measure
					return false;
				});
			});
		});
		
		// Add global handler to ensure feature card modals can be closed with escape key
		document.addEventListener('keydown', function(e) {
			if (e.key === 'Escape') {
				const openModals = document.querySelectorAll('.feature-card-modal[style*="display: flex"]');
				openModals.forEach(modal => {
					modal.style.display = 'none';
					
					// Find the card that owns this modal and restore its position
					const allFeatureCards = document.querySelectorAll('.cmp-flindersonline-feature-card');
					allFeatureCards.forEach(featureCard => {
						const popupCards = featureCard.querySelectorAll('.card__popupmodal');
						popupCards.forEach(popupCard => {
							if (popupCard.modalReference === modal) {
								if (popupCard.modalOriginalParent && popupCard.modalOriginalNextSibling) {
									popupCard.modalOriginalParent.insertBefore(modal, popupCard.modalOriginalNextSibling);
								} else if (popupCard.modalOriginalParent) {
									popupCard.modalOriginalParent.appendChild(modal);
								}
							}
						});
					});
				});
			}
		});
	}

	function setupPillAnimation() {
		featureCards.forEach(card => {
			// Check if this is an author environment
			isAuthor = card.dataset.author === 'true';

			// Find pill shaped pointer cards
			const pillCards = card.querySelectorAll('.card__pill-shaped-pointers');
			
			pillCards.forEach((pillCard) => {
				const pillRows = pillCard.querySelectorAll('.pill-row');
				
				if (pillRows.length === 0) return;
				
				// Set initial state for all pill row contents using GSAP
				const pillRowContents = pillCard.querySelectorAll('.pill-row-content');
				
				if (isAuthor) {
					// In author mode, make pills visible immediately without animation
					gsap.set(pillRowContents, {
						opacity: 1,
						x: 0,
						transformOrigin: "right center"
					});
					return; // Skip animation setup in author mode
				}
				
				gsap.set(pillRowContents, {
					opacity: 0,
					x: 400,
					transformOrigin: "right center"
				});
				
				// Create animation timeline
				const animatePillRows = () => {
					const tl = gsap.timeline();
					
									// Animate each row with staggered timing
				pillRowContents.forEach((rowContent, index) => {
					// Get the card container dimensions
					const cardRect = pillCard.getBoundingClientRect();
					const rowRect = rowContent.getBoundingClientRect();
					
					// Find all pill items in this specific row
					const pillItems = rowContent.querySelectorAll('.pill-item, .pill, [class*="pill"]');
					
					// Determine x animation value based on this row's content overflow
					let xValue = 20; // Default positive value for rows that fit
					
					if (pillItems.length > 0) {
						// Calculate the total width of all pills in this row
						let totalPillsWidth = 0;
						let lastPillRight = 0;
						
						pillItems.forEach(pill => {
							const pillRect = pill.getBoundingClientRect();
							// Calculate relative to the row start position
							const pillRelativeRight = pillRect.right - rowRect.left;
							lastPillRight = Math.max(lastPillRight, pillRelativeRight);
						});
						
						// Check if this row's content overflows the available card width
						const availableWidth = cardRect.width;
						const rowContentWidth = lastPillRight;
						const overflowAmount = rowContentWidth - availableWidth;
						
						
						if (overflowAmount > 0) {
							// This row overflows, slide it left to show all content
							xValue = -(overflowAmount + 30); // Extra padding for better visibility
						} else {
							// This row fits well, use default positive animation
							xValue = 20;
						}
					} else {
						// Fallback: check row content width if no pill items found
						const rowContentWidth = rowRect.width;
						const availableWidth = cardRect.width;
						
						if (rowContentWidth > availableWidth) {
							const overflowAmount = rowContentWidth - availableWidth;
							xValue = -(overflowAmount + 30);
						}
					}
					
					tl.to(rowContent, {
						opacity: 1,
						x: xValue,
						duration: 1.2,
						ease: "power3.out",
						transformOrigin: "right center"
					}, index * 0.2); // Stagger each row by 0.2 seconds
				});
					
					return tl;
				};
				
				// Track if animation has been triggered
				let hasAnimated = false;
				
				// Function to trigger animation
				const triggerAnimation = () => {
					if (hasAnimated) return;
					hasAnimated = true;
					animatePillRows();
				};
				
				// Intersection Observer to trigger animation when in view
				const observerOptions = {
					threshold: 0.3, // Trigger when 30% of the element is visible
					rootMargin: '0px 0px -50px 0px' // Trigger slightly before the element is fully in view
				};
				
				const observer = new IntersectionObserver((entries) => {
					entries.forEach(entry => {
						if (entry.isIntersecting) {
							triggerAnimation();
							// Stop observing once animation is triggered
							observer.unobserve(entry.target);
						}
					});
				}, observerOptions);
				
				// Start observing the pill card
				observer.observe(pillCard);
				
				// Fallback: If Intersection Observer is not supported
				if (!window.IntersectionObserver) {
					// Check scroll position periodically
					const checkScroll = () => {
						if (hasAnimated) return;
						
						const rect = pillCard.getBoundingClientRect();
						const windowHeight = window.innerHeight;
						
						// If element is in viewport
						if (rect.top < windowHeight * 0.8 && rect.bottom > 0) {
							triggerAnimation();
							// Remove scroll listener once animated
							window.removeEventListener('scroll', checkScroll);
						}
					};
					
					// Initial check
					checkScroll();
					
					// Add scroll listener
					window.addEventListener('scroll', checkScroll, { passive: true });
				}
				
				// Handle window resize to recalculate positions
				let resizeTimeout;
				const handleResize = () => {
					clearTimeout(resizeTimeout);
					resizeTimeout = setTimeout(() => {
						// Re-evaluate animation trigger if needed
						if (!hasAnimated) {
							const rect = pillCard.getBoundingClientRect();
							const windowHeight = window.innerHeight;
							
							if (rect.top < windowHeight * 0.8 && rect.bottom > 0) {
								triggerAnimation();
							}
						}
					}, 150);
				};
				
				window.addEventListener('resize', handleResize);
				
				// Store cleanup function for potential future use
				pillCard._cleanupPillAnimation = () => {
					if (observer) {
						observer.disconnect();
					}
					window.removeEventListener('resize', handleResize);
					clearTimeout(resizeTimeout);
				};
			});
		});
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", function () {
			initFeatureCards();
		});
	} else {
		requestAnimationFrame(function () {
			initFeatureCards();
		});
	}
})();